// not sure if map type is the best name for this
export const MAP = 'map';
export const TRAIL = 'trail';
